import EntityMember from "../../entity-member";
import Guid from "../../../../../common/values/guid/guid";

export default class SimpleEntityMemberApiResponse {
  userId?: string;
  entityId?: string;
  firstName?: string;
  lastName?: string;

  deserialize(): EntityMember {
    if (!this.userId || Guid.isEmpty(this.userId)) {
      throw new Error("userId is required");
    }
    if (!this.entityId || Guid.isEmpty(this.entityId)) {
      throw new Error("entityId is required");
    }

    return new EntityMember(new Guid(this.entityId), new Guid(this.userId));
  }
}
